import { object } from 'yup';

import { validateYupTextField } from '../validateList';

export const employeeChangeNameValidationSchema = object().shape({
  employee_name: validateYupTextField.required('fillField'),
});
